export default __webpack_public_path__ + "static/media/rnr-sports-table-13.2f775bb4.webp";